module.exports = __webpack_public_path__ + "static/NeoFruits-0d50697eb5d3c7f6db9e989dbc995a87.jpg";